// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollPatientAccountAttestationAttribute {
    static getAttributeTypeMap() {
        return EnrollPatientAccountAttestationAttribute.attributeTypeMap;
    }
}
EnrollPatientAccountAttestationAttribute.discriminator = undefined;
EnrollPatientAccountAttestationAttribute.additionalProperties = false;
EnrollPatientAccountAttestationAttribute.attributeTypeMap = [
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
];
//# sourceMappingURL=enrollPatientAccountAttestationAttribute.js.map